import IcUserProfile from 'assets/images/ic-user-profile.svg'
import { formatDateMoment, getRatingImage } from 'utils/utils'
import IcThumbsUp from 'assets/images/ic-thumbs-up.svg'
import IcThumbsDown from 'assets/images/ic-thumbs-down.svg'

export const TABLE_PRODUCT_REVIEW_DETAIL = {
    name: 'Comment',
    column: [
        {
            name: 'Nama',
            key: 'name',
            render: ({ item }) => (
                <div className={'flex flex-row items-center space-x-4'}>
                    <img src={IcUserProfile} alt={'IcUserProfile'} className={'w-8 h-8 rounded-full'} />
                    <div>
                        <p>{item.fullname}</p>
                        <p>{item.email}</p>
                    </div>
                </div>
            ),
        },
        {
            name: 'Rating',
            key: 'rate',
            width: 150,
            className: 'justify-center',
            render: ({ value }) => (
                <div className={'flex space-x-1'}>
                    {getRatingImage(value).map((item, index) => (
                        <img key={index} src={item} alt={'star'} className={'w-3'} />
                    ))}
                </div>
            ),
        },
        {
            name: 'Comment',
            key: 'review',
            width: 300,
            render: ({ value }) => <p className={'line-clamp-3'}>{value}</p>,
        },
        {
            name: 'Like/Dislike',
            key: 'like',
            render: ({ item }) => (
                <div className={'space-y-1'}>
                    <div className={'flex flex-row items-center space-x-2'}>
                        <img src={IcThumbsUp} alt={'IcThumbsUp'} />
                        <p>{item?.total_like}</p>
                    </div>
                    <div className={'flex flex-row items-center space-x-2'}>
                        <img src={IcThumbsDown} alt={'IcThumbsDown'} />
                        <p>{item?.total_dislike}</p>
                    </div>
                </div>
            ),
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
    ],
}

export const SORT_PRODUCT_REVIEW_DETAIL = [
    {
        label: 'Sort By Rating Desc',
        key: 'rating-desc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Rating Asc',
        key: 'rating-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Likes Desc',
        key: 'like-desc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Likes Asc',
        key: 'like-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-all-review',
    },
]
